import { Switch, MenuItem } from '@blueprintjs/core'
import React from 'react'
const style = {
  marginTop: 0,
  marginBottom: 0,
} as const

type Props = {
  onClick?: ((event: React.MouseEvent<HTMLElement, MouseEvent>) => void) &
    ((event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void)
  checked: boolean
  label: string
  shouldDismissPopover?: boolean
  disabled?: boolean
}

/**
 * Switch that can be used in place of menu items,
 * special things about this is that the Switchs tag-name is span instead of the default
 * (label), which is undesireable if you're listening to click events from a parent component.
 * and the margins are set to zero.
 */
const MenuItemSwitch = ({
  onClick,
  checked,
  label,
  shouldDismissPopover = false,
  disabled,
}: Props) => (
  <MenuItem
    shouldDismissPopover={shouldDismissPopover}
    onClick={onClick}
    text={
      <Switch
        tagName="span"
        inline
        style={style}
        checked={checked}
        disabled={disabled}
        label={label}
      />
    }
  />
)

export default MenuItemSwitch
